import { Map } from 'mapbox-gl';
import { useEffect } from 'react';

import { MAP_SOURCES } from '../../../components/map/constants.ts';

export const useSetCursor = (map?: Map) => {
  useEffect(() => {
    map?.on('mouseenter', MAP_SOURCES.PINS, () => {
      map.getCanvas().style.cursor = 'pointer';
    });

    map?.on('mouseleave', MAP_SOURCES.PINS, () => {
      map.getCanvas().style.cursor = '';
    });
  }, [map]);
};
